import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { OutcomesSection } from '../components/OutcomesSection';
import { BonusesSection } from '../components/BonusesSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#FAF7F2] overflow-x-hidden" data-id="element-155">
      <HeroSection data-id="element-156" />
      <IdentificationSection data-id="element-157" />
      <MechanismSection data-id="element-158" />
      <DifferenceSection data-id="element-159" />
      <OutcomesSection data-id="element-160" />
      <BonusesSection data-id="element-161" />
      <FinalCTASection data-id="element-162" />
      <Footer data-id="element-163" />
      <SocialProofPopup data-id="element-164" />
    </div>;
}